import Icon from '../components/Icon.vue'

Icon.register({
  meteor: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M491.2 0.7c12.4-3.7 23.8 7.7 20.2 20.1-11.6 38.7-34.3 111.7-61.3 187.7 7 2.1 13.4 4 18.6 5.6 9.7 3 14.2 13.9 9.5 22.9-22.1 42.3-82.7 152.8-142.5 214.4-1 1.1-2 2.5-3 3.5-38.1 38.1-88 57.1-137.9 57.1-49.9 0.1-99.8-19-137.8-57-38-38.1-57-88-57-137.8 0-49.9 19-99.8 57.1-137.8 1-1 2.4-2 3.5-3 61.6-59.9 172-120.4 214.4-142.5 9-4.7 19.9-0.2 22.9 9.5 1.6 5.1 3.5 11.6 5.6 18.6 75.9-27 149-49.7 187.7-61.3zM192 448c70.7 0 128-57.3 128-128s-57.3-128-128-128-128 57.3-128 128 57.3 128 128 128zM160 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM208 352c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z'
      }
    ]
  }
})
